import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles } from 'Components/ComponentLibrary/Styles';
import ListItem2 from 'Components/ComponentLibrary/Components/ListItems/ListItem2';
import ListItemText1 from 'Components/ComponentLibrary/Components/Uncategorized/ListItemText/ListItemText1';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import CheckCircleRounded from '@material-ui/icons/CheckCircleRounded';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import AvatarPicker from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/DetailListItem/AvatarPicker';
import DeleteButtonWithConfirmation from 'Components/ComponentLibrary/Components/Buttons/DeleteButtonWithConfirmation';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import { StatusError } from 'Consts/Status';


const styles = (theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(2, 3),
  },
  primaryTextNoWrap: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  secondaryText: {},
});

const DetailListItem = ({
  className,
  classes,
  onClick,
  onDelete,
  resource,
  deleteDialogProps,
  wrapText,
  ...rest
}) => {
  const isComplete = resource.isTruthy('isComplete');
  const isPending = resource.isTruthy('isPending');
  const isError = resource.attr('status') === StatusError;
  const theme = useTheme();

  function handleClick() {
    if (onClick) onClick();
  }

  let color = isComplete ? 'accentBlue20' : 'lightGray5';
  if (isPending) {
    color = 'accentYellow1';
  }
  if (isError) {
    color = 'brightRed12';
  }

  const hasCheckMarkIcon = resource.attr('hasCheckmarkIcon') && resource.isTruthy('hasCheckmarkIcon');

  const iconColor = hasCheckMarkIcon ? 'accentGreen' : theme.palette.action.active;

  return (
    <ListItem2
      className={classNames(classes.root, className)}
      color={color}
      ContainerComponent={'div'}
      onClick={handleClick}
      button={!!onClick && !hasCheckMarkIcon}
      {...rest}
    >
      <AvatarPicker
        className={classes.avatar}
        resource={resource}
        isError={isError}
      />
      <ListItemText1
        disableTypography
        primary={
          <Typography
            className={classNames({ [classes.primaryTextNoWrap]: !wrapText })}
            variant={'h4'}
            weight={'extraBold'}
            color={'black'}
            test={'survey-detail-list-item-primary-text'}
          >
            {resource.attr('primaryText')}
          </Typography>
        }
        secondary={
          <RichTextDisplay
            className={classes.secondaryText}
            test={'survey-detail-list-item-secondary-text'}
            content={resource.attr('secondaryText')}
          />
        }
      />
      {onDelete ? (
        <DeleteButtonWithConfirmation
          onDelete={onDelete}
          dialogProps={Object.assign({
            title: 'Are you sure?',
            message: 'Would you like to permanently delete this item?',
            cancelLabel: 'Cancel',
            confirmLabel: 'Delete',
          }, deleteDialogProps)}
        />
      ) : null}
      {(resource.link('next') || onClick) ? (
        <Icon
          stroke={iconColor}
          fill={iconColor}
          icon={hasCheckMarkIcon ? CheckCircleRounded : KeyboardArrowRightIcon}
        />
      ) : null}
    </ListItem2>
  );
};

DetailListItem.defaultProps = {
  className: '',
  onClick: undefined,
  onDelete: undefined,
  deleteDialogProps: {},
  wrapText: false,
};

DetailListItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  resource: PropTypes.object.isRequired,
  deleteDialogProps: PropTypes.object,
  wrapText: PropTypes.bool,
};

export default withStyles(styles)(DetailListItem);
